import React from "react";
import { EuiFlexItem } from "@elastic/eui";
import { RepartosCPUserComponent } from "../../../ui/src/routes/Usuarios/RepartosCP/component";

export const CPsCellRenderer = (params:any) => {

  if (params.node.rowPinned) {
    return null;
  }

  if(params.data.tieneRepartos)
  {
  return (
    <EuiFlexItem>
      <RepartosCPUserComponent labelButton={params.value} params={params.data}/>
    </EuiFlexItem>
  )
  }else{return (<EuiFlexItem className="centerCell">{params.value}</EuiFlexItem>)}
};